// extracted by mini-css-extract-plugin
module.exports = {"ProductSearchForm":"ProductSearchForm_ProductSearchForm__1HaKl","SearchInput":"ProductSearchForm_SearchInput__1xy0K"};